import React from 'react';

import { DatePicker } from 'antd';

import locale from 'antd/es/date-picker/locale/en_US';

const DatePickerEnglish = (props) => <DatePicker locale={locale} {...props} />;
export default DatePickerEnglish;
